"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Legend = void 0;
var react_1 = __importStar(require("react"));
var Chart_1 = require("./Chart");
function defaultclick(_a) {
    var dispatch = _a.dispatch, serie = _a.serie, chart = _a.chart;
    dispatch({ type: "toggleHidden", payLoad: serie.label });
}
function Legend() {
    var _a;
    var chart = (0, react_1.useContext)(Chart_1.ChartContext);
    var dispatch = chart.dispatch;
    var isHidden = (0, Chart_1.useIsSerieHidden)();
    var click = (0, react_1.useCallback)((_a = chart.legendClick) !== null && _a !== void 0 ? _a : defaultclick, [chart.legendClick]);
    return react_1.default.createElement("div", { className: 'chart-legend' }, chart.data.map(function (s) { return react_1.default.createElement("div", { key: s.label, onClick: function () { return click({ chart: chart, serie: s, dispatch: dispatch }); }, className: "".concat(s.style, " ").concat(isHidden(s.label) ? 'serie-hidden' : '') }, s.label); }));
}
exports.Legend = Legend;
//# sourceMappingURL=Legend.js.map